import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'
import { START } from 'pu-data/QuoteSteps';
import PriceMatrixCell from './PriceMatrixCell'

const generateQuantityCell = (props) => {
  if (props.hideQuantityCell) return null;

  return (
    <td
      key={`${props.quantity}-quantity`}
      className="qty"
      rowSpan={props.rowSpanQuantityCell}>{props.quantity}
    </td>
  )
}

const generateUsCombinedCells = (props) => {
  const { usCombined } = props
  if (!usCombined) return null;

  const cells = usCombined.lead_times.map((leadTime, col) => {
    const price = usCombined.matrix[props.quantity.toString()][props.groupName][leadTime.toString()];
    return (<PriceMatrixCell key={col} {...props} price={price} leadTime={leadTime} />)
  })
  return cells
}

const shouldDrawRow = (props) => {
  // const { priceRow } = props;
  const { quantity } = props

  const usPriceRow = props.usCombined.matrix[quantity.toString()][props.groupName]
  // const makerPriceRow = props.makerCombined.getIn(['matrix', quantity.toString(), props.groupName])

  if (usPriceRow) {
    return true
  }
  return false
}

const PriceMatrixRow = (props) => {
  let cells = [];

  // dont draw grpa row on start quote
  if (props.groupName === 'grpa' && props.quoteStep === START) return null;

  if (!shouldDrawRow(props)) return null;

  cells = _.concat(cells, generateQuantityCell(props))
  cells = _.concat(cells, generateUsCombinedCells(props))
  // cells = _.concat(cells, generateMakerCells(props))

  return (
    <tr className={props.groupName === 'grpa' ? 'row-best-price' : 'row-customer-price'}>
      {cells}
    </tr>
  );
};

PriceMatrixRow.defaultProps = {
  leadTimes: [],
  hideQuantityCell: false,
  rowSpanQuantityCell: 1,
};

PriceMatrixRow.propTypes = {
  groupName: PropTypes.string.isRequired,
  quoteStep: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  hideQuantityCell: PropTypes.bool,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
  usCombined: PropTypes.shape({
    matrix: PropTypes.object.isRequired,
    lead_times: PropTypes.array.isRequired,
  }),
}
export default PriceMatrixRow;
